import React, { useEffect } from "react";

function GoogleSignInButton({ onSignInSuccess }) {
  useEffect(() => {
    window.google.accounts.id.initialize({
      client_id:
        "774052214276-ib8l9gabg3kmis9s1a4v05v81e72r4r9.apps.googleusercontent.com",
      callback: handleCredentialResponse,
    });
    window.google.accounts.id.renderButton(
      document.getElementById("gsi-button"),
      {
        // type: "icon",
        theme: "filled_blue", // or 'filled_blue' / 'filled_black'
        size: "small", // or 'medium' / 'small'
        text: "signin_with", // use 'signup_with' or 'continue_with'
      }
    );
  }, []);
  function handleCredentialResponse(response) {
    // Send the credential to your Node.js server for verification
    //console.log("handleCredentialResponse");
    var url =
      window.location.hostname === "localhost"
        ? "http://localhost:3001/api/google-signin"
        : "https://kungfu.net/api/google-signin";

    // console.log(url);
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ credential: response.credential }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          onSignInSuccess(data);
        } else {
          //console.error("Sign-in failed:", data.error);
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  }
  return <div id="gsi-button"></div>;
}
export default GoogleSignInButton;
